import { ConfigProvider } from 'antd';

import { AuthProvider } from './context/AuthContext';
import { ModalProvider } from './context/ModalContext';
import { AppRoutes } from './routes/AppRoutes';

import './index.css';

const antTheme = {
  token: {
    colorPrimary: '#ff8e8e',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f4f7f6',
    colorBorder: '#edf2f7',
    colorTextSecondary: '#64748b',
    borderRadius: 10,
    borderRadiusLG: 16,
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
    colorSuccess: '#22c55e',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    fontSize: 14,
    controlHeight: 38,
  },
  components: {
    Button: {
      colorPrimary: '#1a1a1a',
      colorPrimaryHover: '#ff8e8e',
      colorPrimaryActive: '#ff8e8e',
      primaryShadow: 'none',
      fontWeight: 600,
      paddingInline: 20,
      controlHeight: 42,
      paddingBlock: 12,
    },
    Layout: { siderBg: '#1a1a1a', headerBg: '#ffffff' },
    Menu: {
      darkItemBg: '#1a1a1a',
      darkSubMenuItemBg: '#111111',
      darkItemColor: '#94a3b8',
      darkItemHoverBg: 'rgba(255,255,255,0.1)',
      darkItemSelectedBg: 'rgba(255,255,255,0.1)',
      darkItemSelectedColor: '#ffffff',
    },
    Switch: {
      colorPrimary: '#22c55e',
      colorPrimaryHover: '#16a34a',
    },
    Table: {
      headerBg: '#f8fafc',
      headerColor: '#64748b',
      headerSortActiveBg: '#f8fafc',
    },
  },
};

export function App() {
  return (
    <ConfigProvider theme={antTheme}>
      <AuthProvider>
        <ModalProvider>
          <AppRoutes />
        </ModalProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
